import { render } from "./PrivateNetworking.vue?vue&type=template&id=162bb7e4"
import script from "./PrivateNetworking.vue?vue&type=script&lang=js"
export * from "./PrivateNetworking.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__